<app-content-page>
  <blockquote>
    <pre>
      {{ licenses }}
    </pre>
  </blockquote>
</app-content-page>
